import * as yup from 'yup';
import { onlyLetters, ukPostalCode } from 'shared/regex/regex';

const exportObject = {
  requiredAddressLine() {
    return yup
      .string()
      .nullable()
      .required('This field is required.');
  },
  optionalAddressLine() {
    return yup.string().nullable();
  },
  city() {
    return yup
      .string()
      .nullable()
      .required('This field is required.')
      .typeError('City is invalid')
      .matches(onlyLetters, 'City is invalid')
      .min(3, 'City should contain at least 3 characters');
  },
  county() {
    return yup.string().nullable();
  },
  postcode() {
    return yup
      .string()
      .nullable()
      .required('This field is required.')
      .matches(ukPostalCode, {
        excludeEmptyString: true,
        message: `Postcode is invalid.`,
      });
  },
};

export default exportObject;
